import { render, staticRenderFns } from "./pro_03_heat_seal.vue?vue&type=template&id=10504649&lang=pug&"
import script from "./pro_03_heat_seal.vue?vue&type=script&lang=js&"
export * from "./pro_03_heat_seal.vue?vue&type=script&lang=js&"
import style0 from "./pro_03_heat_seal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports